import Image from "next/image";
import React, { useState, useRef, useEffect } from 'react';
import { Icon } from "@iconify/react";
import useLogin from "@/hooks/useLogin";
import Modal from '@/components-mobile/Modal';
import LoginModal from "@/components/LoginModal";
import FreeSamplePopup from '@/components-mobile/FreeSamplePopup';
import { APICapInvitation, APIRefreshCapStatus } from '@/api';
import styles from './index.module.scss';

const ProductCard = ({ sourceData, typePage, obtain, collectChange, addChange, goDetailPage, switchObtain }) => {
  const { needLogin } = useLogin();
  const [getFreeSample, setGetFreeSample] = useState(false);
  const [collected, setCollected] = useState(sourceData.collect);
  const [openTipSample, setOpenTipSample] = useState(false);
  const [code, setcode] = useState();
  const [noEligible, setNoEligible] = useState(false);
  const [eligibleModal, setEligibleModal] = useState(false);  // 签约成功
  const [eligible7dayModal, setEligible7dayModal] = useState(false);
  const [showConnectTips, setShowConnectTips] = useState(false);  // 登录提示
  // const [obtainRef, setObtainRef] = useState(obtain);
  const img = typePage === 'home' || typePage === 'collection'
    ? sourceData.alyImage ? sourceData.alyImage : sourceData.image
    : typePage === 'commission'
      ? sourceData.productImage
      : sourceData?.main_images?.[0]?.url;
  const finishRate = sourceData.finishRate ? sourceData?.finishRate + '%' : "-";

  useEffect(() => {
    console.log('~111111', obtain);
    // getUserInfo();
  }, []);
  const toggleCollect = (e) => {
    if (!needLogin) {
      setCollected(!collected);
    }
    collectChange(e, sourceData, collected);
  };
  const tipList = [
    {
      text: 'Top Selling',
      color: '#FF6C4F',
      bg: 'rgba(248, 240, 237, 0.94)',
      isShow: sourceData?.productTag2 === 1 ? true : false
    },
    {
      text: 'Trending',
      color: '#E04DB1',
      bg: 'rgba(248, 237, 247, 0.94)',
      isShow: sourceData?.productTag3 === 1 ? true : false
    },
    {
      text: 'Free Sample',
      color: '#1DA963',
      bg: 'rgba(232, 241, 239, 0.94)',
      isShow: sourceData?.productTag1 === 1 ? true : false
    }
  ];
  const tipGoSample = () => {
    let user = localStorage.getItem("user");
    user = JSON.parse(user);
    if (needLogin) {
      setShowConnectTips(true);
      return;
    }
    if (!obtain) {
      setOpenTipSample(true);
    }
  };

  const getCapInvite = () => {
    // gaTracker.trackEvent("profile_obtain");
    APICapInvitation()
      .then((resp) => {
        if (resp.code === '1' && resp?.data?.result?.isSucess) {
          setEligibleModal(true);
        } else if (!resp?.data?.result?.isSucess) {
          setEligible7dayModal(true);
        }
        setcode(resp?.data?.result?.code);
      }).catch((e) => { console.log(e); });
  };
  const reEligible = () => {
    // gaTracker.trackEvent("profile_already");
    APIRefreshCapStatus()
      .then((resp) => {
        if (resp?.data?.result) {
          // setObtainRef(true);
          switchObtain();
        } else {
          setNoEligible(true);
        }
      });
  };
  return (
    <div id='step2' className={styles.productCard} >
      <div className={styles.imageBox} onClick={() => { goDetailPage(sourceData); }}>
        <img className={`${styles.image} ${typePage === 'commission' && styles.imageCom}`} src={img} />
        <div className={styles.tipBox}>
          {tipList.map((item, index) => (<div key={index}>
            {item.isShow && <div className={styles.tip} style={{ background: item.bg, color: item.color }}>{item.text}</div>}
          </div>)
          )}
        </div>
        <div className={styles.collectBox}>
          <Icon icon='solar:star-bold-duotone'
            className={`${styles.collect} ${collected ? styles.collectActive : ''}`}
            onClick={(e) => { toggleCollect(e, sourceData); }} />
        </div>
        <div className={styles.mainInfo}>
          <div className={styles.title}>{sourceData.title}</div>
          <div className={styles.price}>{sourceData?.price ?? "-"}</div>
        </div>
      </div>
      <div className={styles.contentEarn}>
        <div className={styles.earnTitle}>${obtain ? sourceData?.capEarnPer ?? "-" : sourceData?.earnPer ?? "-"}</div>
        <div className={styles.earnText}>Earn per sale</div>
      </div>
      <div className={styles.earns}>
        <div className={styles.earnsWarp}>
          <div className={styles.earnsMin}>
            <span className={`${styles.earnNum} ${obtain && styles.earnNumDiff}`}>{finishRate}</span>
            {!obtain && <Icon icon='dashicons:yes-alt' className={styles.earnsMinIcon} />}
          </div>
          <div className={styles.earnsTip}>Earnings</div>
        </div>
        <Icon icon='quill:arrow-right' className={styles.earnGo} />
        <div className={styles.earnsWarp} onClick={tipGoSample}>
          <div className={`${styles.earnsMax} ${obtain && styles.earnsMaxDiff}`}>
            <span className={styles.earnNum}>{`${sourceData?.capRate}%` ?? "-"}</span>
            {obtain
              ? <Icon icon='dashicons:yes-alt' className={styles.earnsMinIcon} />
              : <Icon icon='mdi:lock' className={styles.earnsMaxIcon} />}
          </div>
          <div className={styles.earnsTip}>Max Earnings</div>
        </div>
      </div>
      <div className={styles.button}>
        <div className={styles.sample} onClick={(e) => {
          e.stopPropagation();
          let user = localStorage.getItem("user");
          user = JSON.parse(user);
          if (needLogin) {
            setShowConnectTips(true);
            return;
          }
          setGetFreeSample(true);
        }}>
          <Image width={16} height={16} className={"w-4 h-4 mr-1"} src={"/images/free-sample.svg"} alt={""}></Image>Sample</div>
        <div className={styles.add} onClick={(e) => { addChange(e, sourceData); }}>
          <Image width={16} height={16} className={"w-4 h-4 mr-1"} src={"/images/add-showcase.svg"} alt={""} />Add</div>
      </div>
      <FreeSamplePopup
        isVisible={getFreeSample}
        sourceData={sourceData}
        obtainRef={obtain}
        closePopup={() => setGetFreeSample(false)}
        getCapInvite={() => {
          getCapInvite();
          setGetFreeSample(false);
        }}
        reEligible={() => {
          reEligible();
          setGetFreeSample(false);
        }}
        title={'Get Sample'}
        addChange={(e) => addChange(e, sourceData)}
      />
      {
        openTipSample && <Modal cancel={() => setOpenTipSample(false)}
          type='sample'
          getCapInvite={() => {
            getCapInvite();
            setOpenTipSample(false);
          }}
          reEligible={() => {
            reEligible();
            setOpenTipSample(false);
          }} />
      }
      {
        eligibleModal && <Modal type={'success'} cancel={() => { setEligibleModal(false); }}>
          <div>we'll send you a Linking Invite and more partner details from our affiliate account <span className={styles.tipTextDiff}>Uango</span> to your TikTok. Simply check the link we sent and <span className={styles.tipTextDiff}>accept the request!</span></div>
        </Modal>
      }
      {
        eligible7dayModal && <Modal
          cancel={() => setEligible7dayModal(false)}
        >
          {code === 16004004 && <div>Sorry, you are not a TikTok shop creator and have no permission to bind.</div>}
          {code === 16004005 && <div>Sorry, you already joined TikTok affiliate's Creator Affiliate Program. If you already joined us, please click the<span className={styles.tipTextDiff}> I'm already eligible</span> button to update your data. If you joined another organization, please<span className={styles.tipTextDiff}> cancel your contract</span> and join us again.</div>}
          {code === 16004006 && <div>We've sent you a <span className={styles.tipTextDiff}>anyStarr or partner link </span>and more detailed partnership details from an account in the name of Uango to your TikTok, please check it and click the <span className={styles.tipTextDiff}>accept request</span>!</div>}
          {code === 16004014 && <div>Sorry, you can't join our Creator Affiliate Program because you have a TikTok shop.</div>}
          {code === 16007119 && <div>Sorry, we are currently only open for the <span className={styles.tipTextDiff}>US market,</span> your account region does not match the market!</div>}
          {code !== 16004004
            && code !== 16004005
            && code !== 16004006
            && code !== 16004014
            && code !== 16007119
            && code !== 0
            && <div>Sorry, an error of unknown origin has occurred, please wait for our staff to contact you.</div>}
        </Modal>
      }
      {
        noEligible && <Modal cancel={() => setNoEligible(false)}>
          <div>Join our <span className={styles.tipTextDiff}>Creator Affiliate Program</span> to enjoy the highest commission rate, click the <span className={styles.tipTextDiff}>Obtain Eligibility</span> button to join us!</div>
        </Modal>
      }
      <LoginModal open={showConnectTips} mobile={true} onCancel={() => setShowConnectTips(false)}></LoginModal>
    </div>
  );
};
export default ProductCard;
